import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
  /**
   * 取得購物車
   * @param commit
   * @returns {AxiosPromise<any>}
   */
  fetchCart({ commit }) {
    return request
      .get('/cart')
  },

  /**
   * 移除購物車
   * @param commit
   * @returns {AxiosPromise<any>}
   */
  removerCart({ commit } = {}) {
    return request
      .get('/cart/clear')
  },

  /**
   * 加入購物車
   * @param commit
   * @param eventAlias
   * @param eventSeriesNum
   * @param meals
   * @param sessionUuids
   * @returns {AxiosPromise<any>}
   */
  storeCart({ commit }, {
    eventAlias,
    eventSeriesNum,
    meals,
    sessionUuids,
  } = {}) {
    return request
      .post(`/cart/addItem`, {
        eventAlias,
        eventSeriesNum,
        meals,
        sessionUuids,
      },{
        ...configRequest,
        name: 'storeCart'
      })
  },

  /**
   * 結帳購物車
   * @param commit
   * @param couponCode
   * @param fullName
   * @param email
   * @param gender
   * @param phoneCode
   * @param phoneNumber
   * @param note
   * @returns {AxiosPromise<any>}
   */
  checkOutCart({ commit }, {
    couponCode,
    fullName,
    email,
    gender,
    phoneCode,
    phoneNumber,
    note
  } = {}) {
    return request
      .post('cart/checkout', {
        couponCode,
        fullName,
        email,
        gender,
        phoneCode,
        phoneNumber,
        note
      }, {
        ...configRequest,
        showMessage: false,
        name: 'checkOutCart'
      })
  },
};
